document.addEventListener("DOMContentLoaded", function(){

    var mobile = document.querySelector("#mobile_input");
    if(mobile !== null){
        mobile_input = window.intlTelInput(mobile,{
            utilsScript: '/intl-tel-input-16.0.0/build/js/utils.js',
            separateDialCode: true
        });
    }

    $('#resume_file').on('change',function(){
        const resume_file = document.getElementById('resume_file');
        if(resume_file.files.length > 0){
            const fsize = resume_file.files.item(0).size;
            const file = Math.round((fsize / (1024*1024)));
            if(file >= 4) {
                alert('WARNING: Maximum file size 4MB. This file is ' + file + 'MB. Please choose a smaller file.');
                $('#resume_file').val(null);
            }
        }
    });

    $('#fileUpload').on('change',function(){
        const resume_file = document.getElementById('fileUpload');
        if(resume_file.files.length > 0){
            const fsize = resume_file.files.item(0).size;
            const file = Math.round((fsize / (1024*1024)));
            if(file >= 4) {
                alert('WARNING: Maximum file size 4MB. This file is ' + file + 'MB. Please choose a smaller file.');
                $('#fileUpload').val(null);
            }
        }
    });

});


$(document).ready(function() {

    $('#recruitmentForm').submit(function(e) {
        let is_sim = $(e.target).data('isSim');
        e.preventDefault();
        let formData = new FormData(this);
        let mobile_prefix = $('#mobile_data').find('.iti__selected-dial-code').text();
        formData.append('mobile_prefix',mobile_prefix);
        ajaxCall(formData,is_sim);
    });

    function ajaxCall(data,is_sim){
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('[name="csrf-token"]').val()
            }
        });
        let url = is_sim ? '/api/application/simclusive' : '/api/application/submit';
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            processData: false,
            contentType: false,
            cache: false,
            success: function(response){
                if(response.success) {
                    $('#author-application-button').attr('disabled',true);
                    $('#error_block').addClass('d-none');
                    window.location.href = response.message;
                } else {
                    $('#error_block').removeClass('d-none');

                    let err_str = '';
                    $.each(response.message, function(index, value) {
                        err_str += '<div>' + value + '</div>';
                    });
                    $('#error_block').html(err_str);

                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('#error_block').offset().top
                    }, 1000);
                }
            },
            error: function(error){
                var err_str = 'There was an error processing your request. Please contact support@sp-ed.com for assistance.';
                if(typeof(error.responseJSON.message) != undefined){
                    err_str = '';
                    $.each(error.responseJSON.message, function(index, value) {
                        err_str += '<div>' + value + '</div>';
                    });
                }
                $('#error_block').removeClass('d-none');
                $('#error_block').html(err_str);
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('#error_block').offset().top
                }, 1000);
            }
        });
    }

});